export { default as GDMHeader } from './GDMHeader';

export type {
  GDMHeaderComponent,
  GDMHeaderDesktopComponent,
  GDMHeaderMobileComponent,
  GDMHeaderMobileProps,
} from './GDMHeader.type';
